import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'snakeCaseToTitleCase'
})
export class SnakeCaseToTitleCasePipe implements PipeTransform {

  transform(value: string): string {
    if (!!value && value.length) {
      const sentence = value.toLowerCase().split('_');
      for (let i = 0; i < sentence.length; i++) {
        sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
      }

      return sentence.join(' ');
    }

    return value;
  }

}
